import { useEffect, useState } from 'react';
import { getTotalJobsPostedByWorkspaceId } from 'wisestep-api';

import { IMISAnalyticsQuery } from '../../IMISAnalyticsQuery';

import CustomCountWithTextCard from './CustomCountWithTextCard';

const TotalJobsPostedAllTime = ({ query }: IMISAnalyticsQuery) => {
  const [totalJobs, setTotalJobs] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalJobsPostedByWorkspaceId(query);
      setTotalJobs(response.data ?? 0);
    };
    fetchData();
  }, [query]);

  return <CustomCountWithTextCard count={totalJobs} text="Total Jobs Posted - Life Time" />;
};

export default TotalJobsPostedAllTime;
